export const normalizeFormDocumentImage = (image = {}) => ({
    ...image,
    id: image.id,
    description: image.description ?? image.name ?? '',
    strLink: image.strLink ?? image.link ?? image.url ?? image.strUrl ?? '',
});

export const normalizeFormDocumentImages = (data) => {
    const items = Array.isArray(data) ? data : (data?.documents ?? []);

    return items.map(normalizeFormDocumentImage);
};
